export default __webpack_public_path__ + "static/media/7VK512.3f01b827.jpg";